import { memo, useState, useEffect, forwardRef } from "react";
// import "./Card.scss";
import "./newCard.scss";
import Joker from "./joker";
import joker_image from "./joker_new.svg"

const CardCSS = forwardRef(({ cardTitle, newClassName, index, clickFn = () => { }, onAnimationEnd = () => { } }, ref) => {
    const [flipped, setFlipped] = useState(false);
    const [displayCard, setDisplayCard] = useState(cardTitle);

    const [symbols] = useState({
        "C": <div className="clubCard"><div className="clubTale"></div></div>,
        "H": <div className="heartCard"></div>,
        "S": <div className="spadeCard"><div className="spadeTale"></div></div>,
        "D": <div className="diamondCard"><div className="diamond-border-bottom"></div><div className="diamond-border-top"></div></div>,
    });

    const isRed = ["D", "H"].includes(displayCard?.slice(-1));
    const displayTitle =
        displayCard !== '-1' ? displayCard?.slice(0, 1) === "T" ? 10 : displayCard?.slice(0, -1) : "";

    // Watch for changes in cardTitle
    useEffect(() => {
        if (displayCard === "-1" && cardTitle !== "-1") {
            // trigger flip animation
            setFlipped(true);

            // After flip, show actual card
            setTimeout(() => {
                setDisplayCard(cardTitle);
                setFlipped(false);
            }, 200); // half of transition (0.6s/2)
        } else {
            setDisplayCard(cardTitle);
        }
    }, [cardTitle]);

    return (
        <div
            ref={ref}
            id="cardBack"
            className={`${newClassName} card-container`}
            onClick={(e) => clickFn(e, index)}
            style={{ "--gameCard": index }}
            onAnimationEnd={onAnimationEnd}
        >
            <div className={`card-inner${flipped ? " flipped" : ""}`}>
                {/* BACK SIDE (initially shown for -1) */}
                {<div className="card-front">
                    {displayCard === "-1" ? (
                        <div className="cardLogo">
                            <div className="cardIcons">
                                {/* <span>{symbols["C"]}</span>
                                <span>{symbols["H"]}</span>
                                <span>{symbols["S"]}</span>
                                <span>{symbols["D"]}</span> */}
                                {Object.values(symbols).map(ele => ele)}
                            </div>
                            <div className="pokerBackCardMainTitle">BALLA</div>
                            <div className="subTitle">GAMES</div>
                        </div>
                    ) : null}
                </div>}

                {/* FRONT SIDE (revealed card) */}
                {<div className="card-back">
                    {displayCard !== "JOKER" ? (
                        <>
                            <h4
                                id="cardTitle"
                                style={{ color: isRed ? "red" : "black" }}
                            >
                                {displayTitle}
                            </h4>
                            <div id="smallSymbol">{symbols[displayCard?.slice(-1)]}</div>
                            <div id="bigSymbol">{symbols[displayCard?.slice(-1)]}</div>
                        </>
                    ) : (
                        <>
                            <h4
                                id="cardTitle"
                                className="jokerTitle"
                                // style={{
                                //     color: "black",
                                //     fontSize: "40px",
                                //     textAlign: "center",
                                // }}
                            >
                                {displayCard}
                            </h4>
                            <div id="bigJoker">
                                {/* <Joker /> */}
                                <img className="jokerImage" src={joker_image}></img>
                            </div>
                        </>
                    )}
                </div>}
            </div>
        </div >
    );
});

export default memo(CardCSS);
